import { Star, Camera, MapPin } from "lucide-react";

export function SocialProof() {
  return (
    <section className="border-b border-border bg-muted/50 py-6">
      <div className="container-wide">
        <div className="flex flex-col items-center justify-center gap-6 text-center md:flex-row md:gap-8 lg:gap-12">
          {/* Reviews */}
          <div className="flex items-center gap-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-gold-400 text-gold-400" />
              ))}
            </div>
            <span className="font-semibold text-foreground">4.9</span>
            <span className="text-muted-foreground">(200+ reviews)</span>
          </div>

          {/* Separator - hidden on mobile */}
          <div className="hidden h-6 w-px bg-border md:block" />

          {/* Weddings Count */}
          <div className="flex items-center gap-2 text-muted-foreground">
            <Camera className="h-4 w-4 text-primary" />
            <span className="font-medium text-foreground">500+</span>
            <span>weddings captured</span>
          </div>

          {/* Separator - hidden on mobile */}
          <div className="hidden h-6 w-px bg-border md:block" />

          {/* Service Areas */}
          <div className="flex items-center gap-2 text-muted-foreground">
            <MapPin className="h-4 w-4 text-primary" />
            <span>Serving</span>
            <span className="font-medium text-foreground">NJ • FL • CO</span>
          </div>
        </div>
      </div>
    </section>
  );
}